import React, { forwardRef } from "react";

const InfoButton = forwardRef(function InfoButton(
  { label, isActive, onClick, children },
  ref
) {
  return (
    <div
      ref={ref} // Attaches the ref from parent
      className={`info-btn pos-rel ${isActive ? "expanded" : ""}`}
    >
      <div onClick={onClick} className="splash-link space-between w-100 flex">{label}</div>
      {isActive && <div className="info-expander-inline">{children}</div>}
    </div>
  );
});

export default InfoButton;
